import React, { Component } from 'react';
import { Modal, Select, Checkbox, Button, message } from 'antd';
import DeleteContent from '../../basicElement/DeleteContent';
import fp from '../../../utils/fp';

const { Option } = Select;

class SelectStatisticsDs extends Component {
    state = {
        selected: [],
        visible: false,
    }
    
    show = (selected) => {
        this.setState({
            visible: true,
            selected: [...selected],
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleAdd = () => {
        const { selected } = this.state;
        this.setState({ selected: fp.append({}, selected) });
    }

    handleDelete = (index) => {
        const { selected } = this.state;
        if (!index) {
            message.warning('不能删除服务类型！');
            return;
        }
        if (selected.length === 1) {
            message.warning('至少需保留一个统计维度！');
            return;
        }
        this.setState({ selected: fp.filter((v, i) => i !== index, selected) });
    }

    handleSelectChange = (value, index) => {
        const { statisticsDsList } = this.props;
        const { selected } = this.state;
        // 去除当前项，并将value插入到当前位置
        this.setState({
            selected: fp.compose(
                fp.insert(index)({ ...fp.find(i => i.value === value, statisticsDsList) }),
                fp.filter((v, i) => i !== index)
            )(selected)
        });
    }

    handleCheckChange = (e, index) => {
        const { selected } = this.state;
        selected[index].checked = e.target.checked;
        this.setState({ selected });
    }

    getContent = () => {
        const { statisticsDsList } = this.props;
        const { selected } = this.state;
        return (
            selected.map((item, index) => {
                // 从已选择的列表中去除当前项
                const deleteList = fp.filter(i => i.value !== item.value, selected);
                return (
                    <li className="modal-item" key={item.value}>
                        <div className="item-left">维度{index + 1}</div>
                        <div className="item-right">
                            <DeleteContent
                                onClick={() => this.handleDelete(index)}
                                children={
                                    <Select
                                        placeholder="请选择"
                                        style={{width: 160}}
                                        allowClear={false}
                                        value={item.value}
                                        disabled={index === 0}
                                        onChange={value => this.handleSelectChange(value, index)}
                                    >
                                        {
                                            // 从维度列中去除已选项，并返回Option
                                            fp.compose(
                                                fp.map(i => <Option key={i.value}>{i.name}</Option>),
                                                fp.filter(i => deleteList.every(d => d.value !== i.value))
                                            )(statisticsDsList)
                                        }
                                    </Select>
                                }
                            />
                            {
                                item.checkName &&
                                <Checkbox
                                    checked={item.checked}
                                    onChange={e => this.handleCheckChange(e, index)}
                                >
                                    {item.checkName}
                                </Checkbox>
                            }
                        </div>
                    </li>
                );
            })
        );
    }

    confirm = () => {
        const { selected } = this.state;
        this.hide();
        this.props.onChange({ selected });
    }

    render () {
        const { statisticsDsList } = this.props;
        const { visible, selected } = this.state;
        const disabled = selected.length === statisticsDsList.length;
        return (
            <Modal
                title="选择统计维度"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                maskClosable={false}
                width="400px"
            >
                <div>
                    <Button
                        type="primary"
                        onClick={disabled ? () => void(0) : this.handleAdd}
                        disabled={disabled}
                    >增加统计维度</Button>
                    <div className="modal-content" style={{padding: 0}}>
                        <ul className="modal-list">                 
                            { this.getContent() }
                        </ul>
                    </div>
                </div>
            </Modal>
        );
    }
}

export { SelectStatisticsDs };


// WEBPACK FOOTER //
// ./src/components/financeManagement/orderChangeReport/Widget.js